import { MagazineCardElement } from "@/components/MagazineCard/MagazineCard";
import { MagazinGridModuleType } from "@/modules/MagazinGrid/MagazinGrid.server";
import { requireDefined } from "@/utils/envs";
import { WPClient } from "@/wp/client/WPClient";

/* jscpd:ignore-start */
interface FetchPostsProps {
  page: number;
  postsPerPage: number;
  offset: number;
  locale: string | undefined;
  module: MagazinGridModuleType;
}

export const fetchMagazin = async ({
  module,
  page,
  postsPerPage,
  offset,
  locale,
}: FetchPostsProps) => {
  const defaultLocale = requireDefined(process.env.NEXT_PUBLIC_DEFAULT_LOCALE);

  const client = new WPClient({ locale, defaultLocale });

  const { type, categories, posts: selectedPosts } = module.magazine_grid;
  const postsResult = await client.getPosts({
    type: "magazine",
    page: page,
    perPage: postsPerPage,
    offset,
    fields: [
      "id",
      "date",
      "link",
      "_embedded",
      "acf.header_magazine",
      "categories",
    ],
    ...(type === "posts" && {
      includeIds: { ids: selectedPosts || [], keepOrder: true },
    }),
    ...(type === "categories" && {
      includeCategories: [{ category: "category", ids: categories || [] }],
    }),
  });

  const posts = postsResult.posts.map((post) => {
    const header = post.acf?.header_magazine;
    //! uncomment this if you want to use categories
    // const _categories = post._embedded?.["wp:term"]
    //   ? post._embedded["wp:term"][0]
    //   : [];
    return {
      title: header.title,
      subline: header.subline,
      excerpt: header.excerpt,
      image: header.image,
      link: post.link,
    } as MagazineCardElement;
  });

  return {
    posts,
    totalPosts: postsResult.totalPosts,
  };
};

/* jscpd:ignore-end */
